import React from "react";
import parse from "html-react-parser";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";

export default function PluroDoctors({ title, data }) {
  return (
    <section className="pluro-doctors-wrapper">
      <div className="container">
        <h2 className="pluro-doctors-title">{parse(title)}</h2>
        
        <div className="pluro-doctors-grid">
          {data.map((item, index) => (
            <div className="pluro-doctor-card" key={index}>
              <div className="pluro-doctor-img-container">
                <img src={item.imgUrl} alt={item.name} />
              </div>
              <div className="pluro-doctor-info">
                <h3>{item.name}</h3>
                <p>{item.designation}</p>
                {item.experience && <p>{item.experience}</p>}
                {item.description && <p className="cs_member_description" style={{ marginTop: '10px' }}>{item.description}</p>}
                
                {item.social && (
                  <div className="cs_social_links" style={{ justifyContent: 'center', marginTop: '15px' }}>
                    {item.social.map((socialItem, idx) => (
                      <Link to={socialItem.href} key={idx}>
                        <Icon icon={socialItem.icon} />
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
